import { render, staticRenderFns } from "./joinedBusiness.vue?vue&type=template&id=0578295c&scoped=true&lang=html"
import script from "./joinedBusiness.vue?vue&type=script&lang=js"
export * from "./joinedBusiness.vue?vue&type=script&lang=js"
import style0 from "./joinedBusiness.vue?vue&type=style&index=0&id=0578295c&prod&lang=css"
import style1 from "./joinedBusiness.vue?vue&type=style&index=1&id=0578295c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578295c",
  null
  
)

export default component.exports